import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  FaChartLine,
  FaUser,
  FaShieldAlt,
  FaBolt,
  FaBullseye,
  FaArrowRight,
} from "react-icons/fa";

import logo from "../assets/TW logo img.jpeg";

function Home() {
  return (
    <div style={{ background: "#f5f8fc", minHeight: "100vh" }}>
      {/* Top Brand Bar */}
      <div
        style={{
          background: "#0f172a",
          padding: "16px 0",
        }}
      >
        <Container>
          <div className="d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center">
              <div
                style={{
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                  border: "2px solid #22c55e",
                  overflow: "hidden",
                  background: "#fff",
                  marginRight: "12px",
                }}
              >
                <img
                  src={logo}
                  alt="Trading Wealth"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>

              <div>
                <h3 className="text-white fw-bold mb-0">
                  Trading Wealth
                </h3>

                <small style={{ color: "#cbd5e1" }}>
                  Professional Stock Market Advisory Platform
                </small>
              </div>
            </div>

            <Link to="/customer-login">
              <Button variant="success">
                Login
              </Button>
            </Link>
          </div>
        </Container>
      </div>

      {/* Hero Section */}
      <Container className="py-5">
        <Row className="align-items-center">
          <Col lg={6}>
            <div
              className="mb-3"
              style={{
                display: "inline-block",
                background: "#dcfce7",
                color: "#166534",
                padding: "8px 16px",
                borderRadius: "30px",
                fontWeight: "600",
              }}
            >
              <FaShieldAlt className="me-2" />
              Trusted Stock Advisory Platform
            </div>

            <h1
              className="fw-bold"
              style={{
                fontSize: "52px",
                color: "#0f172a",
                lineHeight: "1.15",
              }}
            >
              Trade Smarter.
              <br />
              Invest Better.
            </h1>

            <p
              className="text-muted mt-4"
              style={{
                fontSize: "20px",
                lineHeight: "1.8",
              }}
            >
              Get professional stock market calls for short term,
              mid term and long term opportunities with clear buy
              levels, targets, stop loss and real-time status updates.
            </p>

            <div className="mt-4 d-flex flex-wrap gap-3">
              <Link to="/customer-login">
                <Button variant="success" size="lg">
                  <FaUser className="me-2" />
                  Customer Login
                </Button>
              </Link>
            </div>

            <Row className="mt-5">
              <Col sm={4} className="mb-3">
                <h3 className="fw-bold text-success mb-0">
                  24/7
                </h3>
                <small className="text-muted">
                  Online Access
                </small>
              </Col>

              <Col sm={4} className="mb-3">
                <h3 className="fw-bold text-success mb-0">
                  Live
                </h3>
                <small className="text-muted">
                  Call Status
                </small>
              </Col>

              <Col sm={4} className="mb-3">
                <h3 className="fw-bold text-success mb-0">
                  Smart
                </h3>
                <small className="text-muted">
                  Risk Control
                </small>
              </Col>
            </Row>
          </Col>

          <Col lg={6} className="mt-5 mt-lg-0">
            <Card
              className="border-0 shadow-lg"
              style={{
                borderRadius: "24px",
                overflow: "hidden",
              }}
            >
              <Card.Body className="p-4">
                <h3 className="fw-bold mb-2">
                  Advisory Services
                </h3>

                <p className="text-muted mb-4">
                  Choose the right opportunity based on your trading style.
                </p>

                <Card className="mb-3 border-0 shadow-sm">
                  <Card.Body className="d-flex align-items-start">
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "14px",
                        background: "#dcfce7",
                        color: "#15803d",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "15px",
                        fontSize: "22px",
                      }}
                    >
                      <FaChartLine />
                    </div>

                    <div>
                      <h5 className="fw-bold mb-1">
                        Long Term Calls
                      </h5>

                      <p className="text-muted mb-0">
                        Build wealth with fundamentally strong companies
                        and long-term investment ideas.
                      </p>
                    </div>
                  </Card.Body>
                </Card>

                <Card className="mb-3 border-0 shadow-sm">
                  <Card.Body className="d-flex align-items-start">
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "14px",
                        background: "#dbeafe",
                        color: "#1d4ed8",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "15px",
                        fontSize: "22px",
                      }}
                    >
                      <FaBullseye />
                    </div>

                    <div>
                      <h5 className="fw-bold mb-1">
                        Mid Term Calls
                      </h5>

                      <p className="text-muted mb-0">
                        Swing trading opportunities backed by research,
                        levels and market movement.
                      </p>
                    </div>
                  </Card.Body>
                </Card>

                <Card className="border-0 shadow-sm">
                  <Card.Body className="d-flex align-items-start">
                    <div
                      style={{
                        width: "48px",
                        height: "48px",
                        borderRadius: "14px",
                        background: "#fef3c7",
                        color: "#b45309",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginRight: "15px",
                        fontSize: "22px",
                      }}
                    >
                      <FaBolt />
                    </div>

                    <div>
                      <h5 className="fw-bold mb-1">
                        Short Term Calls
                      </h5>

                      <p className="text-muted mb-0">
                        Quick trading opportunities with buy range,
                        target, stop loss and status tracking.
                      </p>
                    </div>
                  </Card.Body>
                </Card>

                <div className="d-grid mt-4">
                  <Link to="/customer-login">
                    <Button variant="success" size="lg" className="w-100">
                      View Stock Calls
                      <FaArrowRight className="ms-2" />
                    </Button>
                  </Link>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Why Trading Wealth */}
      <Container className="pb-5">
        <Row>
          <Col md={4} className="mb-3">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body>
                <h5 className="fw-bold">
                  Clear Entry Levels
                </h5>

                <p className="text-muted mb-0">
                  Calls include buy range, target, stop loss and CMP tracking.
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className="mb-3">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body>
                <h5 className="fw-bold">
                  Active Status Updates
                </h5>

                <p className="text-muted mb-0">
                  Know whether a call is active, target hit, exit,
                  closed or stop loss hit.
                </p>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className="mb-3">
            <Card className="border-0 shadow-sm h-100">
              <Card.Body>
                <h5 className="fw-bold">
                  Customer Access Control
                </h5>

                <p className="text-muted mb-0">
                  Only active subscribers can access premium stock recommendations.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* Disclaimer */}
      <Container className="pb-5">
        <Card className="border-0 shadow-sm">
          <Card.Body>
            <h6
              className="fw-bold mb-2"
              style={{
                color: "#64748b",
                fontSize: "13px",
              }}
            >
              Disclaimer
            </h6>

            <p
              className="text-muted mb-0"
              style={{
                fontSize: "11px",
                lineHeight: "1.6",
              }}
            >
              Investments in the stock market are subject to market risk.
              Market-linked ideas shared by Trading Wealth are for informational
              and learning purposes. Price movement may vary based on market
              conditions, volatility and individual decision-making. Users are
              encouraged to review suitability and risk before acting on any
              market view.
            </p>
          </Card.Body>
        </Card>
      </Container>

      <footer
        className="text-center py-4"
        style={{
          background: "#0f172a",
          color: "#cbd5e1",
        }}
      >
        © 2026 Trading Wealth. All Rights Reserved.
      </footer>
    </div>
  );
}

export default Home;